/* tslint:disable */

declare var Object: any;
export interface RegisterInterface {
  "id"?: number;
}

export class Register implements RegisterInterface {
  "id": number;
  constructor(data?: RegisterInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Register`.
   */
  public static getModelName() {
    return "Register";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Register for dynamic purposes.
  **/
  public static factory(data: RegisterInterface): Register{
    return new Register(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Register',
      plural: 'Registers',
      path: 'Registers',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Register.ts